import React, { useMemo, useCallback } from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Linking } from 'react-native';
import { useRoute } from '@react-navigation/native';
import { RESIDENTS_MOBILE_COLORS } from '@/constants/residents/mobile/color';

export const RoommateDetailScreen: React.FC = () => {
  const route = useRoute<any>();
  const roommate = route.params?.roommate;

  const first = roommate?.data?.account?.firstName || roommate?.firstName || '';
  const last = roommate?.data?.account?.lastName || roommate?.lastName || '';
  const name = `${first} ${last}`.trim() || 'Roommate';
  const email = roommate?.data?.account?.email || roommate?.email || '';
  const phoneRaw = roommate?.data?.account?.phoneNumber || roommate?.data?.account?.phone || roommate?.phoneNumber || roommate?.phone || '';
  const unit = roommate?.data?.account?.unitNumberSpace || roommate?.data?.account?.unitNumber || roommate?.unitNumberSpace || roommate?.unitNumber || '';
  const bio = roommate?.data?.account?.roommateBio || roommate?.data?.account?.bio || roommate?.roommateBio || roommate?.bio || '';

  const initials = useMemo(() => {
    return `${first?.[0] || ''}${last?.[0] || ''}`;
  }, [first, last]);

  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <View style={styles.avatarLarge}>
          <Text style={styles.avatarLargeText}>{initials}</Text>
        </View>
        <Text style={styles.name}>{name}</Text>
        {!!unit && <Text style={styles.sub}>{unit}</Text>}
      </View>

      <View style={styles.section}>
        {!!email && (
          <TouchableOpacity style={styles.row} onPress={() => Linking.openURL(`mailto:${email}`)}>
            <Text style={styles.label}>Email</Text>
            <Text style={styles.value}>{email}</Text>
          </TouchableOpacity>
        )}
        {!!phoneRaw && (
          <TouchableOpacity style={styles.row} onPress={() => Linking.openURL(`tel:${phoneRaw}`)}>
            <Text style={styles.label}>Phone</Text>
            <Text style={styles.value}>{phoneRaw}</Text>
          </TouchableOpacity>
        )}
      </View>

      {!!bio && (
        <View style={styles.section}>
          <Text style={styles.about}>About</Text>
          <Text style={styles.bio}>{bio}</Text>
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: RESIDENTS_MOBILE_COLORS.BACKGROUND_PRIMARY,
    padding: 16,
  },
  header: {
    alignItems: 'center',
    paddingVertical: 20,
  },
  avatarLarge: {
    height: 88,
    width: 88,
    borderRadius: 44,
    backgroundColor: '#E5E5EA',
    alignItems: 'center',
    justifyContent: 'center',
  },
  avatarLargeText: {
    fontWeight: '700',
    color: RESIDENTS_MOBILE_COLORS.TEXT_PRIMARY,
    fontSize: 28,
  },
  name: {
    fontSize: 18,
    fontWeight: '700',
    color: RESIDENTS_MOBILE_COLORS.TEXT_PRIMARY,
    marginTop: 12,
  },
  sub: {
    fontSize: 13,
    color: RESIDENTS_MOBILE_COLORS.TEXT_PRIMARY,
    opacity: 0.8,
    marginTop: 4,
  },
  section: {
    marginTop: 16,
  },
  about: {
    fontSize: 16,
    fontWeight: '700',
    color: RESIDENTS_MOBILE_COLORS.TEXT_PRIMARY,
    marginBottom: 8,
  },
  bio: {
    fontSize: 14,
    color: RESIDENTS_MOBILE_COLORS.TEXT_PRIMARY,
  },
  row: {
    paddingVertical: 12,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: RESIDENTS_MOBILE_COLORS.BORDER_PRIMARY,
  },
  label: {
    fontSize: 13,
    color: RESIDENTS_MOBILE_COLORS.TEXT_PRIMARY,
    opacity: 0.7,
    marginBottom: 4,
  },
  value: {
    fontSize: 15,
    color: RESIDENTS_MOBILE_COLORS.TEXT_PRIMARY,
  },
});

export default RoommateDetailScreen;


